import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export default [
  {
    gridXs: 3,
    stateKey: 'advisor_type',
    label: i18n.t('TYPE_KEY'),
    isSelect: true,
    options: [
      { value: 'all', label: i18n.t('ALL_KEY') },
      {
        value: 'empty_instances_weekday',
        label: i18n.t('EMPTY_INSTANCES_WEEKDAY_NIGHT_KEY'),
      },
      {
        value: 'empty_instances_saturday',
        label: i18n.t('EMPTY_INSTANCES_SATURDAY_KEY'),
      },
      {
        value: 'empty_instances_sunday',
        label: i18n.t('EMPTY_INSTANCES_SUNDAY_KEY'),
      },
      {
        value: 'empty_instances_any_day',
        label: i18n.t('EMPTY_INSTANCES_ANY_DAY_KEY'),
      },
      {
        value: 'dynamic_advisor_weekday_start',
        label: i18n.t('DYNAMIC_ADVISOR_WEEKDAY_START_KEY'),
      },
      {
        value: 'dynamic_advisor_weekday_end',
        label: i18n.t('DYNAMIC_ADVISOR_WEEKDAY_END_KEY'),
      },
    ],
  },
  {
    gridXs: 3,
    stateKey: 'status',
    label: i18n.t('STATUS_KEY'),
    isSelect: true,
    options: [
      { value: 'all', label: i18n.t('ALL_KEY') },
      { value: 'pending', label: i18n.t('PENDING_KEY') },
      { value: 'applied', label: i18n.t('APPLIED_KEY') },
      {
        value: 'expired',
        label: i18n.t('DEPRECIATED_KEY'),
      },
      {
        value: 'ignored',
        label: i18n.t('IGNORED_KEY'),
      },
      {
        value: 'reverted',
        label: i18n.t('REVERTED_KEY'),
      },
    ],
  },
  {
    gridXs: 3,
    stateKey: 'environment_type',
    label: i18n.t('BEHAVIOR_KEY'),
    isSelect: true,
    options: [
      { value: 'all', label: i18n.t('ALL_KEY') },
      {
        value: 'period',
        label: i18n.t('OPERATION_MODE_PERIOD_KEY'),
      },
      {
        value: 'micro',
        label: i18n.t('OPERATION_MODE_MICRO_KEY'),
      },
      {
        value: 'spot_period',
        label: i18n.t('OPERATION_MODE_SPOT_PERIOD_KEY'),
      },
    ],
  },
  {
    gridXs: 3,
    stateKey: 'impact',
    label: i18n.t('RISK_KEY'),
    isSelect: true,
    options: [
      { value: 'all', label: i18n.t('ALL_KEY') },
      {
        value: 'low',
        label: i18n.t('LOW_IMPACT_KEY'),
      },
      {
        value: 'medium',
        label: i18n.t('MEDIUM_IMPACT_KEY'),
      },
      {
        value: 'high',
        label: i18n.t('HIGH_IMPACT_KEY'),
      },
    ],
  },
] as GenericFormItem[];
